export default __webpack_public_path__ + "static/media/configr-custom.b9e789ee.svg";